<template>
  <ProgressCard
    :title="$t('xia-zai-lie-biao')"
    :list="progressList"
    type="download"
    @close="onClose"
  >
    <template #content="{ dataSource }">
      <div class="text-right text-font-80 text-[12px]">
        <span v-if="dataSource?.status === 'fail'" class="text-error">{{
          dataSource?.msg
        }}</span>
        <span v-else-if="dataSource?.status === 'wait'">{{
          dataSource?.msg
        }}</span>
        <span v-else>{{ dataSource?.percent }} %</span>
      </div>
    </template>
    <template #action="{ dataSource }">
      <iconpark-icon
        v-if="dataSource.percent === 100"
        name="check-thin"
        class="text-[16px] text-success"
      ></iconpark-icon>
      <a-tooltip v-if="dataSource.status === 'fail'" placement="topRight">
        <template #title>{{ $t('zhong-shi') }}</template>
        <iconpark-icon
          name="refresh"
          class="text-[16px] text-font-80 mr-[5px]"
          @click="reDownload(dataSource)"
        ></iconpark-icon>
      </a-tooltip>
      <a-tooltip
        v-if="dataSource.percent !== 100 || dataSource.status === 'fail'"
        placement="topRight"
      >
        <template #title>{{ $t('guan-bi-xia-zai') }}</template>
        <iconpark-icon
          name="close"
          class="text-[16px] text-font-40"
          @click="() => cancelFetch(dataSource.id)"
        ></iconpark-icon>
      </a-tooltip>
    </template>
  </ProgressCard>
</template>

<script lang="ts" setup>
const progressInfo = useProgress()

interface Data {
  cover: string
  id: string
  url: string
  title: string
}

const progressList = ref<Data[]>([])
const percentMap = ref<{
  [key: string]: { percent: number; status?: string; msg?: string }
}>({})

const cancelFun = ref<{
  [key: string]: { abort?: () => void }
}>({})

const onProcess = (
  receivedLength: number,
  totalLength: number,
  id: number,
  status?: string,
  msg?: string
) => {
  progressList.value = progressList.value.map((item: any) => {
    if (item?.id === id) {
      return {
        ...item,
        percent: Math.floor((receivedLength / totalLength) * 100) || 0,
        status,
        msg,
      }
    }
    return item
  })
  percentMap.value[id] = {
    percent: Math.floor((receivedLength / totalLength) * 100) || 0,
    // status,
    // msg,
  }
}

const onCancel = (id: string, callback: any) => {
  cancelFun.value[id] = callback
}

const cancelFetch = (id: string) => {
  cancelFun.value[id]?.abort?.()
  progressList.value = progressList.value.filter((item) => item.id !== id)

  if (!progressList.value.length) {
    setProgress(PROGRESS_TYPE.DOWNLOAD, undefined)
  }
}

const downloadNum = computed(() => {
  return progressList.value.filter((item: any) => item.percent !== 100)?.length
})

watch(
  () => downloadNum.value,
  (cur, before) => {
    if (cur !== before && progressList.value.length) {
      setProgress(PROGRESS_TYPE.DOWNLOAD, {
        count: cur,
      })
    }
  }
)

watch(
  () => progressInfo.value?.download?.list,
  (cur, before) => {
    if (cur !== before && cur) {
      const detail =
        cur.map((o: any) => ({
          ...o,
          id: uuid(),
        })) || []
      progressList.value = detail.concat(progressList.value)

      downloadVideo()
    }
  }
)

const downloadVideo = () => {
  progressList.value?.forEach((detail: Data) => {
    if (!percentMap.value[detail.id]) {
      downloadFileFromUrl(detail.url[0], detail, onProcess, onCancel)
    }
  })
}

const reDownload = (item: any) => {
  downloadFileFromUrl(item.url[0], item, onProcess, onCancel)
}

const onClose = () => {
  progressList.value = []
  percentMap.value = {}
}
</script>

<style lang="scss">
.youyan-video-progress {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 21;

  .modal-title {
    @apply px-[16px] py-[8px];
    border-bottom: 1px solid var(--back-3);
  }
  .progress-line {
    .ant-progress-bg {
      height: 2px !important;
    }
  }
  .content {
    @apply w-[500px] z-30 bg-back-1 rounded-[8px];
    border: 1px solid var(--back-3);
    box-shadow: 0px 2px 19px 0px rgba(0, 0, 0, 0.1);
  }
  .progress-item {
    &:first-child {
      margin-top: 0;
    }
    .text-color {
      color: rgba(255, 255, 255, 0.3);
    }
  }
}
</style>
